import React, { FC, useMemo } from "react"
import { turbine } from "neql"
import { AppDetailBase } from "../../../../AppDetailBase/AppDetailBase"
import { useNeqlContextProvider } from "../../../../../../../../../Hooks/useNeqlContextProvider"
import { decodeFilterAndSort } from "../../../../../../../../../Models/Client/FilterAndSortExpression"
import { defaultGroundTruthSort } from "../../../../../../../../../Models/API/APIGroundTruthModel"
import { BaselineContentPool } from "./BaselineContentPool"
import { Redirect, RouteComponentProps } from "react-router"
import { routePaths } from "../../../../../../../../../Routes"

interface QualifierTestContentProps {
    orgUsername: string
    appID: string
    qualifierID: string
}

export const QualifierTestContent: FC<
    RouteComponentProps<QualifierTestContentProps>
> = ({
    match: {
        params: { appID, qualifierID, orgUsername }
    },
    location
}) => {
    const clientContext = useNeqlContextProvider("turbine")

    const qualifier = turbine.useFetchTrainingTestQuery({
        variables: {
            trainingTestId: qualifierID
        },
        client: clientContext
    }).data?.trainingTest

    const { title, body, breadcrumbs } = useMemo(() => {
        const baselineFilterAndSort = decodeFilterAndSort(
            new URLSearchParams(location.search),
            defaultGroundTruthSort
        )
        if (!baselineFilterAndSort.isError) {
            return {
                title: `${qualifier?.taskInfo?.title ?? ""} content pool`,
                breadcrumbs: [
                    "Workers",
                    "Worker qualification",
                    "Test content pool"
                ],
                body: (
                    <BaselineContentPool
                        orgUsername={orgUsername}
                        appID={appID}
                        qualifierID={qualifierID}
                        filterAndSort={baselineFilterAndSort.value}
                    />
                )
            }
        }
        return {
            title: "Content pool",
            breadcrumbs: ["Workers", "Worker qualification", "Content"],
            body: (
                <Redirect
                    to={routePaths.appQualifierTestContent(
                        orgUsername,
                        appID,
                        qualifierID
                    )}
                />
            )
        }
    }, [appID, location.search, orgUsername, qualifier, qualifierID])

    const baseProps = useMemo(
        () => ({
            id: appID,
            title,
            breadcrumbs,
            fixedContentWidth: false,
            orgUsername
        }),
        [appID, breadcrumbs, orgUsername, title]
    )

    return <AppDetailBase {...baseProps}>{body}</AppDetailBase>
}
